import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import TaskListMainItem from "./TaskListMainItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchTaskList } from "../../actions/task";
import InfoBox from "../../components/Reusable/InfoBox";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const TaskList = () => {
  const dispatch = useDispatch();

  const { taskList } = useSelector((state) => state.taskReducer);
  const [activeCategory, setActiveCategory] = useState("unfinished");
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  useEffect(() => {
    dispatch(fetchTaskList("unfinished"));
  }, [dispatch]);

  const changeCategoryTask = (type) => {
    setActiveCategory(type);
    dispatch(fetchTaskList(type));
  };

  return (
    <div className="task-main-container">
      <Breadcrumb title={t("taskList.breadcrumbTitle")} returnPage="/" />

      <div className="task-list-container">
        <h1>{t("taskList.taskSuccessMessage")}</h1>

        <div className="task-list-category">
          <div className="task-list-category-items">
            <div
              className={`task-list-category-item ${
                activeCategory === "unfinished" ? "active" : ""
              }`}
              onClick={() => changeCategoryTask("unfinished")}
            >
              {t("taskList.categoryUnfinished")}
            </div>
            <div
              className={`task-list-category-item ${
                activeCategory === "finished" ? "active" : ""
              }`}
              onClick={() => changeCategoryTask("finished")}
            >
              {t("taskList.categoryFinished")}
            </div>
            <div
              className={`task-list-category-item ${
                activeCategory === "failed" ? "active" : ""
              }`}
              onClick={() => changeCategoryTask("failed")}
            >
              {t("taskList.categoryFailed")}
            </div>
          </div>
        </div>
        <div className="task-list-items">
          {taskList?.length === 0 ? (
            <InfoBox text={t("taskList.noTasksMessage")} />
          ) : (
            taskList?.map((task, key) => (
              <TaskListMainItem item={task} key={key} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskList;
